//TO MUSI BYĆ ABY BUNDLE ZAWIERAŁ KLASY Z components
//TS nie kompiluje nieużywanych klas??
import "dce-i18n";
import "dce-components";
import "dce-engine";
import "dce-logger";
import "dce-ajax"
import "dce-fragments"
import "dce-fragments-components"
import "dce-live-events"
import "dce-jsx"
import "dce-websocket"
import "dce-tiptap"
import "dce-pikaday"
import "dce-fullcalendar"

import "app"

import { DceEngine } from "dce-engine";
import { DceJsx } from "dce-jsx";
import {DceWebSocketConnection} from "dce-websocket";

DceEngine.start();
DceWebSocketConnection.openConnection();
